import { VariableDefinition, VariablesMap } from '../Bot/Bot.Model'
import { SpaceVars } from './SpaceVariables.Interfaces'

export type SwivlVar = UserVars | StoreVars | SpaceVars

export enum UserVars {
  User_Id = 'userId',
  User_Name = 'Entity personName',
  User_Email = 'Entity email',
  User_Phone = 'Entity phonenumber',
  User_AddressLine1 = 'UserAddressLine1',
  User_AddressLine2 = 'UserAddressLine2',
  User_City = 'UserCity',
  User_State = 'UserState',
  User_Zip = 'UserZip',
  User_CountryCode = 'UserCountryCode',

  User_EntityCity = 'User_EntityCity',
  User_EntityState = 'User_EntityState',
  User_EntityDate = 'User_EntityDate',
  User_EntityTime = 'User_EntityTime',
  User_EntityNumber = 'User_EntityNumber',

  User_LastIntent = 'UserLastIntent',
  User_AccountStatus = 'UserAccountStatus',
  User_AccountPaymentStatus = 'UserAccountPaymentStatus',
  User_HasCompletedProfile = 'UserHasCompletedProfile', // they've given us a full profile (name, email, phone)
  User_HasConfirmedProfile = 'UserHasConfirmedProfile',
  User_HasShortProfile = 'User_HasShortProfile', // they've given us a short profile (name and email or name and phone)
  User_AnsweringMachine = 'UserAnsweringMachine',
  User_Persona = 'UserPersona',
  User_HasUnhandled = 'UserHasUnhandled',
  User_AccountType = 'UserAccountType',

  User_WantsToStoreVehicle = 'UserWantsToStoreVehicle', //1 if user wants to store vehicle
  User_WantToShopByPrice = 'UserWantToShopByPrice', //1 if user wants to shop by price
  User_FilterFeatures = 'UserFilterFeatures',
  User_FilterSize = 'UserFilterSize',

  User_FMSLeadStatus = 'UserLeadStatus',
  User_EmailType = 'UserEmailType',

  User_EmailReceiptType = 'UserEmailReceiptType',

  User_TenantId = 'UserTenantId',

  User_CRMId = 'UserCRMId',
  User_CRMStatus = 'UserCRMStatus',

  User_LastAgentName = 'UserLastAgentName', // This is set as soon as an agent takes over a conversation.

  //User_Lead_hasSentEmailReceipt is a 1 if it email receipt has already been sent to improve duplicate leads
  User_Lead_hasSentEmailReceipt = 'UserLeadhasSentEmailReceipt',

  //User_Lead_hasSentToFMS is a 1 if it has been sent to FMS to improve duplicate leads
  User_Lead_hasSentToFMS = 'UserLeadhasSentToFMS',

  //User Review Variables
  User_Review_NPSScore = 'UserReviewNPSScore',
  User_Review_NPSFeedback = 'UserReviewNPSFeedback',
  User_Review_NPSTopic = 'UserReviewNPSTopic',

  User_UnitNumber = 'UserUnitNumber',
  User_UnitSize = 'UserUnitSize',
  User_UnitFeatures = 'UserUnitFeatures',

  //FMS Variables
  User_AccessCode = 'UserAccessCode',
  User_DavinciAccessCode = 'UserDavinciAccessCode',

  User_PaymentDueDate = 'UserPaymentDueDate',
  User_AutoPayEnabled = 'UserAutoPayEnabled',
  User_DaysPastDue = 'UserDaysPastDue',
  User_AccountBalance = 'User_AccountBalance',

  //1.5 Variables
  User_TemporaryFMSID = 'UserTemporaryFMSID', // this is used to determine if the user has started shopping at a different location
  User_Review_NPSPersona = 'UserReviewFeedbackPersona', // this is Promotor, Passive, or Detractor
  User_hasSeen_FeatureMenu = 'UserhasSeenFeatureMenu',
  User_hasSeen_InventoryMenu = 'UserhasSeenInventoryMenu',
  User_hasSeen_AnythingElseMenu = 'UserhasSeenAnythingElseMenu',
  User_hasSeen_CostMenu = 'UserhasSeenCostMenu',
  User_hasSeen_ContactMenu = 'UserhasSeenContactMenu',
  User_hasSeen_SizeMenu = 'UserhasSeenSizeMenu',
  User_hasSeen_ProblemMenu = 'UserhasSeenProblemMenu',
  User_hasSeen_AccountMenu = 'UserhasSeenAccountMenu',
  User_hasSeen_ChangeAccountMenu = 'UserhasSeenChangeAccountMenu',
  User_hasSeen_AccountLoginMenu = 'UserhasSeenAccountLoginMenu',
  User_hasSeen_PurchaseProcessMenu = 'UserhasSeenPurchaseProcessMenu',
  User_hasSeen_LeaseTermsMenu = 'UserhasSeenLeaseTermsMenu',
  User_hasSeen_MoveMenu = 'UserhasSeenMoveMenu',

  User_Notes = 'UserNotes',

  //1.6 Variables
  User_hasSeen_GSPotentialMenu = 'UserhasSeenGSPotentialMenu',
  User_hasSeen_GSExistingMenu = 'UserhasSeenGSExistingMenu',

  User_FMS_Error = 'UserFMSError',

  //1.7 Variables
  User_hasSeen_SMSDisclaimer = 'UserhasSeenSMSDisclaimer',
  User_CronReceiptType = 'UserCronReceiptType',
  User_AfterNavigate_Holder = 'UserAfterNavigateHolder', // This holds where a user is coming from so that after navigateTo, we can open the chat and continue with specifics regarding what to do next
  User_ProfileCollect_Holder = 'UserProfileCollectHolder', // This holds why a user is being sent to Profile Collect Start quest
  User_PreviousChannel_Holder = 'UserPreviousChannelHolder', // This holds a previous channel so that we can do analytics when navigating from one to another. i.e. GMB/SMS to Web
  User_WantToSearchAnotherStore = 'User_WantToSearchAnotherStore', // used if a user is on a location page and asks to search another store. cleared once get info by URL is bypassed
  User_hasProvidedFeedback = 'User_hasProvidedFeedback', // for review soliciation. do not ask for feedback if they've already provided it
  User_isUpdatingProfile = 'User_isUpdatingProfile', // for Profile Collect 2.0. skip My Storage message if they're updating their profile
  User_selectedStoreFromSMS = 'User_selectedStoreFromSMS', // for SMS to web. point to Welcome instead of Finish in SELECT Store

  //2.1 Variables
  UserinAbandonedCartWorkflow = 'UserinAbandonedCartWorkflow', // they've given us a full profile (name, email, phone)
  UserInterruptedProfileCollect = 'UserInterruptedProfileCollect', // they've asked a question while we were trying to collect their info

  UserReferredBy = 'UserReferredBy',
  UserReferredByName = 'UserReferredByName',
  User_SentimentScore = 'User_SentimentScore',
  User_Sentiment = 'User_Sentiment',

  User_IncomingCallNumber = 'UserIncomingCallNumber'
}
/* ---------------
STORE VARIABLES
-----------------*/
export enum StoreVars {
  StoreLocationNumber = 'StoreLocationNumber',
  StoreFMSIntegrationId = 'StoreFMSIntegrationId',
  StoreGoogleReviewURL = 'StoreGoogleReviewURL',
  StoreName = 'StoreName',
  StoreId = 'StoreId',
  StoreFMSType = 'StoreFMSType',

  StoreCountryCode = 'StoreCountryCode',

  StoreClimateControlDisplayName = 'StoreClimateControlDisplayName',
  StoreFirstFloorDisplayName = 'StoreFirstFloorDisplayName',
  StoreUpperLevelDisplayName = 'StoreUpperLevelDisplayName',
  StoreInsuranceDisplayName = 'StoreInsuranceDisplayName',
  StoreHasElevator = 'StoreHasElevator',
  StoreHasWineStorage = 'StoreHasWineStorage',
  StoreGooglePlaceId = 'StoreGooglePlaceId', // This is the place Id. It is used for GMB.
  StoreGoogleAccountAndLocationName = 'StoreGoogleAccountAndLocationName', // This is the name of the account and  location in googles format. It is used for reviews

  StoreHasBoatStorage = 'StoreHasBoatStorage',

  StoreBrandId = 'StoreBrandId', // This is used to filter out storefinder looksups and the such when one account has multiple brands associated with it(Cubix for example)

  StoreOnlyShowUnitDimensions = 'StoreOnlyShowUnitDimensions',

  StoreAddressLine1 = 'StoreAddressLine1',
  StoreCity = 'StoreCity',

  StoreState = 'StoreState',

  StorePostalCode = 'StorePostalCode',

  StorePhoneNumber = 'StorePhoneNumber',

  StorePayByPhoneNumber = 'StorePayByPhoneNumber',

  StoreAfterHoursPhoneNumber = 'StoreAfterHoursPhoneNumber',

  StoreEmail = 'StoreEmail',

  StoreDMName = 'StoreDMName',

  StoreDMEmail = 'StoreDMEmail',

  StoreWebsiteUrl = 'StoreWebsiteUrl',

  StoreUrlLookupPattern = 'StoreUrlLookupPattern',

  StorePhotoURL = 'StorePhotoURL',

  StoreWalletPassURL = 'StoreWalletPassURL',
  StorePaymentURL = 'StorePaymentURL',
  StoreMapURL = 'StoreMapURL',

  StoreOfficeHours = 'StoreOfficeHours',

  StoreAccessHours = 'StoreAccessHours',
  StoreCallCenterHours = 'StoreCallCenterHours',

  StorePaymentOptions = 'StorePaymentOptions',

  StoreRVStorage = 'StoreRVStorage',

  StoreSmallVehicleStorage = 'StoreSmallVehicleStorage',

  StoreTrailerStorage = 'StoreTrailerStorage',

  StoreDeliveriesAccepted = 'StoreDeliveriesAccepted',

  StoreVideoSurveillance = 'StoreVideoSurveillance',

  StoreSecurityAmenities = 'StoreSecurityAmenities',

  StoreDriveUpUnits = 'StoreDriveUpUnits',

  StoreClimateControlledUnits = 'StoreClimateControlledUnits',

  StoreHeatedUnits = 'StoreHeatedUnits',

  StoreOfficeSpace = 'StoreOfficeSpace',

  StoreConferenceRoom = 'StoreConferenceRoom',

  StoreTruckRentals = 'StoreTruckRentals',

  StoreTwentyFourHourAccess = 'StoreTwentyFourHourAccess',

  StoreLockersAvailable = 'StoreLockersAvailable',

  StoreLockTypes = 'StoreLockTypes',

  StoreTruckTypes = 'StoreTruckTypes',

  StoreParkingType = 'StoreParkingType',

  StoreLoadingAreaType = 'StoreLoadingAreaType',

  StoreLeadUnitId = 'StoreLeadUnitId',

  StoreAppointmentAvailable = 'StoreAppointmentAvailable',

  StoreSpotLocationSlug = 'StoreSpotLocationSlug',
  StoreSpotLinkSlug = 'StoreSpotLinkSlug'
}

//TODO: Make a function to generate these.

export const DefaultBotVariables: VariablesMap = {
  [UserVars.User_Name]: {
    id: UserVars.User_Name,
    name: 'User - Name',

    protected: true
  },
  [UserVars.User_Email]: {
    id: UserVars.User_Email,
    name: 'User - Email',

    protected: true
  },
  [UserVars.User_Phone]: {
    id: UserVars.User_Phone,
    name: 'User - Phone Number',
    protected: true
  },
  [UserVars.User_AddressLine1]: {
    id: UserVars.User_AddressLine1,
    name: 'User - Address Line 1',
    protected: true
  },
  [UserVars.User_AddressLine2]: {
    id: UserVars.User_AddressLine2,
    name: 'User - Address Line 2',
    protected: true
  },

  [UserVars.User_City]: { id: UserVars.User_City, name: 'User - City', protected: true },
  [UserVars.User_State]: { id: UserVars.User_State, name: 'User - State', protected: true },
  [UserVars.User_Zip]: { id: UserVars.User_Zip, name: 'User - Zip', protected: true },
  [UserVars.User_LastIntent]: {
    id: UserVars.User_LastIntent,
    name: 'User - Last Intent',

    protected: true
  },
  [UserVars.User_CountryCode]: {
    id: UserVars.User_CountryCode,
    name: 'User - Country Code',

    protected: true
  },

  [UserVars.User_HasCompletedProfile]: {
    id: UserVars.User_HasCompletedProfile,
    name: 'User - Has Completed Profile?',

    protected: true
  },

  [UserVars.User_HasConfirmedProfile]: {
    id: UserVars.User_HasConfirmedProfile,
    name: 'User - Has Confirmed Profile',

    protected: true
  },

  [UserVars.User_HasShortProfile]: {
    id: UserVars.User_HasShortProfile,
    name: 'User - Has Short Profile',

    protected: true
  },

  [UserVars.User_AnsweringMachine]: {
    id: UserVars.User_AnsweringMachine,
    name: 'User - Answering Machine',

    protected: true
  },
  [UserVars.User_Persona]: {
    id: UserVars.User_Persona,
    name: 'User - Persona',

    protected: true
  },
  [UserVars.User_HasUnhandled]: {
    id: UserVars.User_HasUnhandled,
    name: 'User - Has Unhandled',

    protected: true
  },
  [UserVars.User_AccountType]: {
    id: UserVars.User_AccountType,
    name: 'User - Account Type',

    protected: true
  },
  [UserVars.User_CRMId]: {
    id: UserVars.User_CRMId,
    name: 'User - CRM Id',

    protected: true
  },
  [UserVars.User_CRMStatus]: {
    id: UserVars.User_CRMStatus,
    name: 'User - CRM Status',

    protected: true
  },

  [UserVars.User_LastAgentName]: {
    id: UserVars.User_LastAgentName,
    name: 'User - Last Agent Name',

    protected: true
  },

  [UserVars.User_Lead_hasSentEmailReceipt]: {
    id: UserVars.User_Lead_hasSentEmailReceipt,
    name: 'User - Lead Has Sent Email Receipt',

    protected: true
  },
  [UserVars.User_Lead_hasSentToFMS]: {
    id: UserVars.User_Lead_hasSentToFMS,
    name: 'User - Lead Has Sent To FMS',

    protected: true
  },
  [UserVars.User_Review_NPSScore]: {
    id: UserVars.User_Review_NPSScore,
    name: 'User - Review NPS Score',

    protected: true
  },
  [UserVars.User_Review_NPSFeedback]: {
    id: UserVars.User_Review_NPSFeedback,
    name: 'User - Review NPS Feedback',

    protected: true
  },
  [UserVars.User_Review_NPSTopic]: {
    id: UserVars.User_Review_NPSTopic,
    name: 'User - Review NPS Topic',

    protected: true
  },
  [UserVars.User_TemporaryFMSID]: {
    id: UserVars.User_TemporaryFMSID,
    name: 'User - Temporary FMS ID',

    protected: true
  },
  [UserVars.User_Review_NPSPersona]: {
    id: UserVars.User_Review_NPSPersona,
    name: 'User - Review NPS Persona',

    protected: true
  },
  [UserVars.User_hasSeen_FeatureMenu]: {
    id: UserVars.User_hasSeen_FeatureMenu,
    name: 'User - hasSeen Feature Menu',

    protected: true
  },
  [UserVars.User_hasSeen_InventoryMenu]: {
    id: UserVars.User_hasSeen_InventoryMenu,
    name: 'User - hasSeen Inventory Menu',

    protected: true
  },
  [UserVars.User_hasSeen_AnythingElseMenu]: {
    id: UserVars.User_hasSeen_AnythingElseMenu,
    name: 'User - hasSeen AnythingElse Menu',

    protected: true
  },
  [UserVars.User_hasSeen_CostMenu]: {
    id: UserVars.User_hasSeen_CostMenu,
    name: 'User - hasSeen Cost Menu',

    protected: true
  },
  [UserVars.User_hasSeen_ContactMenu]: {
    id: UserVars.User_hasSeen_ContactMenu,
    name: 'User - hasSeen Contact Menu',

    protected: true
  },
  [UserVars.User_hasSeen_SizeMenu]: {
    id: UserVars.User_hasSeen_SizeMenu,
    name: 'User - hasSeen Size Menu',

    protected: true
  },
  [UserVars.User_hasSeen_ProblemMenu]: {
    id: UserVars.User_hasSeen_ProblemMenu,
    name: 'User - hasSeen Problem Menu',

    protected: true
  },
  [UserVars.User_hasSeen_AccountMenu]: {
    id: UserVars.User_hasSeen_AccountMenu,
    name: 'User - hasSeen Account Menu',

    protected: true
  },
  [UserVars.User_hasSeen_ChangeAccountMenu]: {
    id: UserVars.User_hasSeen_ChangeAccountMenu,
    name: 'User - hasSeen ChangeAccount Menu',

    protected: true
  },
  [UserVars.User_hasSeen_AccountLoginMenu]: {
    id: UserVars.User_hasSeen_AccountLoginMenu,
    name: 'User - hasSeen AccountLogin Menu',

    protected: true
  },
  [UserVars.User_hasSeen_PurchaseProcessMenu]: {
    id: UserVars.User_hasSeen_PurchaseProcessMenu,
    name: 'User - hasSeen PurchaseProcess Menu',

    protected: true
  },
  [UserVars.User_hasSeen_LeaseTermsMenu]: {
    id: UserVars.User_hasSeen_LeaseTermsMenu,
    name: 'User - hasSeen LeaseTerms Menu',

    protected: true
  },
  [UserVars.User_hasSeen_MoveMenu]: {
    id: UserVars.User_hasSeen_MoveMenu,
    name: 'User - hasSeen Move Menu',

    protected: true
  },
  [UserVars.User_hasSeen_GSExistingMenu]: {
    id: UserVars.User_hasSeen_GSExistingMenu,
    name: 'User - hasSeen GSExisting Menu',

    protected: true
  },
  [UserVars.User_hasSeen_GSPotentialMenu]: {
    id: UserVars.User_hasSeen_GSPotentialMenu,
    name: 'User - hasSeen GSPotential Menu',

    protected: true
  },
  [UserVars.User_hasSeen_SMSDisclaimer]: {
    id: UserVars.User_hasSeen_SMSDisclaimer,
    name: 'User - hasSeen SMS Disclaimer',

    protected: true
  },
  [UserVars.User_CronReceiptType]: {
    id: UserVars.User_CronReceiptType,
    name: 'User - Cron Receipt Type',

    protected: true
  },
  [UserVars.User_AfterNavigate_Holder]: {
    id: UserVars.User_AfterNavigate_Holder,
    name: 'User - After Navigate Holder',

    protected: true
  },
  [UserVars.User_ProfileCollect_Holder]: {
    id: UserVars.User_ProfileCollect_Holder,
    name: 'User - Profile Collect Holder',

    protected: true
  },
  [UserVars.User_PreviousChannel_Holder]: {
    id: UserVars.User_PreviousChannel_Holder,
    name: 'User - Previous Channel Holder',

    protected: true
  },
  [UserVars.User_WantToSearchAnotherStore]: {
    id: UserVars.User_WantToSearchAnotherStore,
    name: 'User - Wants to Search Another Store',

    protected: true
  },
  [UserVars.User_hasProvidedFeedback]: {
    id: UserVars.User_hasProvidedFeedback,
    name: 'User - Has Provided Feedback',

    protected: true
  },
  [UserVars.User_isUpdatingProfile]: {
    id: UserVars.User_isUpdatingProfile,
    name: 'User - Is Updating Profile',

    protected: true
  },
  [UserVars.User_selectedStoreFromSMS]: {
    id: UserVars.User_selectedStoreFromSMS,
    name: 'User - Selected Store From SMS',

    protected: true
  },
  [UserVars.UserinAbandonedCartWorkflow]: {
    id: UserVars.UserinAbandonedCartWorkflow,
    name: 'User - In Abandoned Cart Workflow',

    protected: true
  },
  [UserVars.UserInterruptedProfileCollect]: {
    id: UserVars.UserInterruptedProfileCollect,
    name: 'User - Interrupted Profile Collect',

    protected: true
  }
}

export const StorageVars: VariablesMap = {
  // StoreLocationNumber: { id: 'StoreLocationNumber', name: 'Store - Location Number',  protected: true }
  [UserVars.User_TenantId]: {
    id: UserVars.User_TenantId,
    name: 'User - Tenant Id',
    protected: true
  },

  [UserVars.User_FMS_Error]: {
    id: UserVars.User_FMS_Error,
    name: 'User - FMS Error',
    protected: true
  },

  [UserVars.User_FMSLeadStatus]: {
    id: UserVars.User_FMSLeadStatus,
    name: 'User - FMS Lead Status',

    protected: true
  },
  [UserVars.User_EmailType]: {
    id: UserVars.User_EmailType,
    name: 'User - Email Type',

    protected: true
  },
  [UserVars.User_EmailReceiptType]: {
    id: UserVars.User_EmailReceiptType,
    name: 'User - Email Receipt Type',

    protected: true
  },
  [UserVars.User_CronReceiptType]: {
    id: UserVars.User_CronReceiptType,
    name: 'User - Cron Receipt Type',

    protected: true
  },

  [UserVars.User_AccessCode]: {
    id: UserVars.User_AccessCode,
    name: 'User - Access Code',

    protected: true
  },
  [UserVars.User_DavinciAccessCode]: {
    id: UserVars.User_DavinciAccessCode,
    name: 'User - Davinci Access Code',
    protected: true
  },
  [UserVars.User_AccountStatus]: {
    id: UserVars.User_AccountStatus,
    name: 'User - Account Status',

    protected: true
  },
  [UserVars.User_AccountPaymentStatus]: {
    id: UserVars.User_AccountPaymentStatus,
    name: 'User - Account Payment Status',

    protected: true
  },
  [UserVars.User_PaymentDueDate]: {
    id: UserVars.User_PaymentDueDate,
    name: 'User - Payment Due Date',

    protected: true
  },

  [UserVars.User_AutoPayEnabled]: {
    id: UserVars.User_AutoPayEnabled,
    name: 'User - Auto Pay Enabled',

    protected: true
  },

  [UserVars.User_DaysPastDue]: {
    id: UserVars.User_DaysPastDue,
    name: 'User - Days Past Due',

    protected: true
  },

  [UserVars.User_WantsToStoreVehicle]: {
    id: UserVars.User_WantsToStoreVehicle,
    name: 'User - Wants to Store Vehicle?',

    protected: true
  },
  [UserVars.User_WantToShopByPrice]: {
    id: UserVars.User_WantToShopByPrice,
    name: 'User - Wants to Shop by Price?',

    protected: true
  },
  [UserVars.User_FilterFeatures]: {
    id: UserVars.User_FilterFeatures,
    name: 'User - Filter Features',
    protected: true
  },
  [UserVars.User_FilterSize]: {
    id: UserVars.User_FilterSize,
    name: 'User - Filter Size',

    protected: true
  },

  [UserVars.User_Notes]: {
    id: UserVars.User_Notes,
    name: 'User - Notes',
    protected: true
  },

  [UserVars.User_UnitNumber]: {
    id: UserVars.User_UnitNumber,
    name: 'User - Unit Number',
    protected: true
  },
  [UserVars.User_UnitSize]: {
    id: UserVars.User_UnitSize,
    name: 'User - Unit Size',
    protected: true
  },
  [UserVars.User_UnitFeatures]: {
    id: UserVars.User_UnitFeatures,
    name: 'User - Unit Features',
    protected: true
  },

  [UserVars.User_AccountBalance]: {
    id: UserVars.User_AccountBalance,
    name: 'User - Account Balance',
    protected: true
  },

  [UserVars.User_EntityCity]: {
    id: UserVars.User_EntityCity,
    name: 'User - Entity City',
    protected: true
  },

  [UserVars.User_EntityState]: {
    id: UserVars.User_EntityState,
    name: 'User - Entity State',
    protected: true
  },

  [UserVars.User_EntityDate]: {
    id: UserVars.User_EntityDate,
    name: 'User - Entity Date',
    protected: true
  },

  [UserVars.User_EntityTime]: {
    id: UserVars.User_EntityTime,
    name: 'User - Entity Time',
    protected: true
  },

  [UserVars.User_EntityNumber]: {
    id: UserVars.User_EntityNumber,
    name: 'User - Entity Time',
    protected: true
  },

  [StoreVars.StoreLocationNumber]: {
    id: StoreVars.StoreLocationNumber,
    name: 'Store - Location Number',

    protected: true
  },
  [StoreVars.StoreId]: {
    id: StoreVars.StoreId,
    name: 'Store - FMS Facility Id',

    protected: true
  },
  [StoreVars.StoreFMSIntegrationId]: {
    id: StoreVars.StoreFMSIntegrationId,
    name: 'Store - FMS Integration Id',

    protected: true
  },
  [StoreVars.StoreFMSType]: {
    id: StoreVars.StoreFMSType,
    name: 'Store - FMS Type',

    protected: true
  },

  [StoreVars.StoreName]: {
    id: StoreVars.StoreName,
    name: 'Store - Name',

    protected: true
  },

  [StoreVars.StoreAddressLine1]: {
    id: StoreVars.StoreAddressLine1,
    name: 'Store - Address Line 1',

    protected: true
  },

  [StoreVars.StoreCity]: {
    id: StoreVars.StoreCity,
    name: 'Store - City',

    protected: true
  },

  [StoreVars.StoreState]: {
    id: StoreVars.StoreState,
    name: 'Store - State',

    protected: true
  },

  [StoreVars.StorePostalCode]: {
    id: StoreVars.StorePostalCode,
    name: 'Store - Postal Code',

    protected: true
  },

  [StoreVars.StorePhoneNumber]: {
    id: StoreVars.StorePhoneNumber,
    name: 'Store - Phone Number',

    protected: true
  },

  [StoreVars.StorePayByPhoneNumber]: {
    id: StoreVars.StorePayByPhoneNumber,
    name: 'Store - Pay by Phone Number',

    protected: true
  },
  [StoreVars.StoreAfterHoursPhoneNumber]: {
    id: StoreVars.StoreAfterHoursPhoneNumber,
    name: 'Store - After Hours Phone Number',

    protected: true
  },
  [StoreVars.StoreEmail]: {
    id: StoreVars.StoreEmail,
    name: 'Store - Email',

    protected: true
  },

  [StoreVars.StoreDMName]: {
    id: StoreVars.StoreDMName,
    name: 'Store - DM Name',

    protected: true
  },

  [StoreVars.StoreDMEmail]: {
    id: StoreVars.StoreDMEmail,
    name: 'Store - DM Email',

    protected: true
  },

  [StoreVars.StoreWebsiteUrl]: {
    id: StoreVars.StoreWebsiteUrl,
    name: 'Store - Location URL',

    protected: true
  },

  [StoreVars.StoreUrlLookupPattern]: {
    id: StoreVars.StoreUrlLookupPattern,
    name: 'Store - URL Lookup Pattern',

    protected: true
  },
  [StoreVars.StorePhotoURL]: {
    id: StoreVars.StorePhotoURL,
    name: 'Store - Photo URL',

    protected: true
  },
  [StoreVars.StoreWalletPassURL]: {
    id: StoreVars.StoreWalletPassURL,
    name: 'Store - Wallet URL',
    protected: true
  },
  [StoreVars.StorePaymentURL]: {
    id: StoreVars.StorePaymentURL,
    name: 'Store - Payment URL',
    protected: true
  },
  [StoreVars.StoreMapURL]: {
    id: StoreVars.StoreMapURL,
    name: 'Store - Map URL',
    protected: true
  },

  [StoreVars.StoreOfficeHours]: {
    id: StoreVars.StoreOfficeHours,
    name: 'Store - Office Hours',

    protected: true
  },

  [StoreVars.StoreAccessHours]: {
    id: StoreVars.StoreAccessHours,
    name: 'Store - Access Hours',
    protected: true
  },

  [StoreVars.StoreCallCenterHours]: {
    id: StoreVars.StoreCallCenterHours,
    name: 'Store - Call Center Hours',
    protected: true
  },

  [StoreVars.StorePaymentOptions]: {
    id: StoreVars.StorePaymentOptions,
    name: 'Store - Payment Options',

    protected: true
  },

  [StoreVars.StoreRVStorage]: {
    id: StoreVars.StoreRVStorage,
    name: 'Store - RV Storage',

    protected: true
  },
  [StoreVars.StoreSmallVehicleStorage]: {
    id: StoreVars.StoreSmallVehicleStorage,
    name: 'Store - Small Vehicle Storage',

    protected: true
  },
  [StoreVars.StoreTrailerStorage]: {
    id: StoreVars.StoreTrailerStorage,
    name: 'Store - Trailer Storage',

    protected: true
  },

  [StoreVars.StoreDeliveriesAccepted]: {
    id: StoreVars.StoreDeliveriesAccepted,
    name: 'Store - Deliveries Accepted',

    protected: true
  },

  [StoreVars.StoreVideoSurveillance]: {
    id: StoreVars.StoreVideoSurveillance,
    name: 'Store - Video Surveillance',

    protected: true
  },

  [StoreVars.StoreSecurityAmenities]: {
    id: StoreVars.StoreSecurityAmenities,
    name: 'Store - Security Amenities',

    protected: true
  },

  [StoreVars.StoreDriveUpUnits]: {
    id: StoreVars.StoreDriveUpUnits,
    name: 'Store - Drive-Up Units',

    protected: true
  },

  [StoreVars.StoreClimateControlledUnits]: {
    id: StoreVars.StoreClimateControlledUnits,
    name: 'Store - Climate Controlled Units',

    protected: true
  },

  [StoreVars.StoreHeatedUnits]: {
    id: StoreVars.StoreHeatedUnits,
    name: 'Store - Heated Units',

    protected: true
  },

  [StoreVars.StoreOfficeSpace]: {
    id: StoreVars.StoreOfficeSpace,
    name: 'Store - Office Space',

    protected: true
  },

  [StoreVars.StoreConferenceRoom]: {
    id: StoreVars.StoreConferenceRoom,
    name: 'Store - Conference Room',

    protected: true
  },
  [StoreVars.StoreTruckRentals]: {
    id: StoreVars.StoreTruckRentals,
    name: 'Store - Truck Rentals',

    protected: true
  },
  [StoreVars.StoreTwentyFourHourAccess]: {
    id: StoreVars.StoreTwentyFourHourAccess,
    name: 'Store - 24 Hour Access',

    protected: true
  },
  [StoreVars.StoreLockersAvailable]: {
    id: StoreVars.StoreLockersAvailable,
    name: 'Store - Lockers Available',

    protected: true
  },
  [StoreVars.StoreLockTypes]: {
    id: StoreVars.StoreLockTypes,
    name: 'Store - Lock Type',

    protected: true
  },
  [StoreVars.StoreTruckTypes]: {
    id: StoreVars.StoreTruckTypes,
    name: 'Store - Truck Type',

    protected: true
  },
  [StoreVars.StoreParkingType]: {
    id: StoreVars.StoreParkingType,
    name: 'Store - Parking Type',

    protected: true
  },

  [StoreVars.StoreLoadingAreaType]: {
    id: StoreVars.StoreLoadingAreaType,
    name: 'Store - Loading Area Type',

    protected: true
  },
  [StoreVars.StoreLeadUnitId]: {
    id: StoreVars.StoreLeadUnitId,
    name: 'Store - Lead Unit Id',

    protected: true
  },

  [StoreVars.StoreAppointmentAvailable]: {
    id: StoreVars.StoreAppointmentAvailable,
    name: 'Store - Appointment Available',

    protected: true
  },

  [StoreVars.StoreGoogleReviewURL]: {
    id: StoreVars.StoreGoogleReviewURL,
    name: 'Store - Google Review URL',

    protected: true
  },

  [StoreVars.StoreClimateControlDisplayName]: {
    id: StoreVars.StoreClimateControlDisplayName,
    name: 'Store - Climate Control Display Name',

    protected: true
  },
  [StoreVars.StoreFirstFloorDisplayName]: {
    id: StoreVars.StoreFirstFloorDisplayName,
    name: 'Store - First Floor Display Name',

    protected: true
  },
  [StoreVars.StoreUpperLevelDisplayName]: {
    id: StoreVars.StoreUpperLevelDisplayName,
    name: 'Store - Upper Level Display Name',

    protected: true
  },
  [StoreVars.StoreInsuranceDisplayName]: {
    id: StoreVars.StoreInsuranceDisplayName,
    name: 'Store - Insurance Display Name ',

    protected: true
  },

  [StoreVars.StoreHasElevator]: {
    id: StoreVars.StoreHasElevator,
    name: 'Store - Has Elevator',

    protected: true
  },

  [StoreVars.StoreHasWineStorage]: {
    id: StoreVars.StoreHasWineStorage,
    name: 'Store - Has Wine Storage',
    protected: true
  },

  [StoreVars.StoreGooglePlaceId]: {
    id: StoreVars.StoreGooglePlaceId,
    name: 'Store - Google Place Id',
    protected: true
  },
  [StoreVars.StoreGoogleAccountAndLocationName]: {
    id: StoreVars.StoreGoogleAccountAndLocationName,
    name: 'Store - Google Account and Location Name',
    protected: true
  },

  [StoreVars.StoreHasBoatStorage]: {
    id: StoreVars.StoreHasBoatStorage,
    name: 'Store - Has Boat Storage',
    protected: true
  },
  [StoreVars.StoreBrandId]: {
    id: StoreVars.StoreBrandId,
    name: 'Store - Brand Id',
    protected: true
  },
  [StoreVars.StoreCountryCode]: {
    id: StoreVars.StoreCountryCode,
    name: 'Store - Country Code',
    protected: true
  },
  [StoreVars.StoreOnlyShowUnitDimensions]: {
    id: StoreVars.StoreOnlyShowUnitDimensions,
    name: 'Store - Only Show Unit Dimensions',
    protected: true
  },

  [StoreVars.StoreSpotLocationSlug]: {
    id: StoreVars.StoreSpotLocationSlug,
    name: 'Store - Spot Location Slug',
    protected: true
  },
  [StoreVars.StoreSpotLinkSlug]: {
    id: StoreVars.StoreSpotLinkSlug,
    name: 'Store - Spot Link Slug',
    protected: true
  },

  /*
   ******   ***** ACE
   *        *   *
   ******   *****
   *   *
   ******   *
   */
  [SpaceVars.SpaceId]: { id: SpaceVars.SpaceId, name: 'Space - Id', protected: true },

  [SpaceVars.SpaceName]: { id: SpaceVars.SpaceName, name: 'Space - Name', protected: true },

  [SpaceVars.SpaceDimensions]: {
    id: SpaceVars.SpaceDimensions,
    name: 'Space - Dimensions',
    protected: true
  },

  [SpaceVars.SpaceRate]: { id: SpaceVars.SpaceRate, name: 'Space - Rate', protected: true },

  [SpaceVars.SpaceHasClimateControl]: {
    id: SpaceVars.SpaceHasClimateControl,
    name: 'Space - Climate Controlled',
    protected: true
  },
  [SpaceVars.SpaceIsInside]: {
    id: SpaceVars.SpaceIsInside,
    name: 'Space - Indoor',
    protected: true
  },
  [SpaceVars.SpaceHasPower]: {
    id: SpaceVars.SpaceHasPower,
    name: 'Space - Has Power',
    protected: true
  },
  [SpaceVars.SpaceFloor]: {
    id: SpaceVars.SpaceFloor,
    name: 'Space - Floor #',
    protected: true
  },
  [SpaceVars.SpaceIsParking]: {
    id: SpaceVars.SpaceIsParking,
    name: 'Space - Is Parking',
    protected: true
  },

  [SpaceVars.SpaceIsDriveUp]: {
    id: SpaceVars.SpaceIsDriveUp,
    name: 'Space - Drive Up',
    protected: true
  },

  [SpaceVars.SpaceHasElevatorAccess]: {
    id: SpaceVars.SpaceHasElevatorAccess,
    name: 'Space - Has Elevator Access',
    protected: true
  },

  [SpaceVars.SpaceHasAlarm]: {
    id: SpaceVars.SpaceHasAlarm,
    name: 'Space - Has Alarm',
    protected: true
  },
  [SpaceVars.SpaceFeatures]: {
    id: SpaceVars.SpaceFeatures,
    name: 'Space - Features',
    protected: true
  }

  // [SpaceVars.SpaceHasVideoSurveillance]: {
  //   id: SpaceVars.SpaceHasVideoSurveillance,
  //   name: 'Space - Video Surveillance',
  //   protected: true
  // },

  // [SpaceVars.SpaceHasInteriorLight]: {
  //   id: SpaceVars.SpaceHasInteriorLight,
  //   name: 'Space - Has Interior Light',
  //   protected: true
  // }
}
